import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import __reactComponentDispatchEvent from '../runtime-helpers/react-component-dispatch-event.js';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7Toolbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7Toolbar, _React$Component);

  function F7Toolbar(props, context) {
    var _this;

    _classCallCheck(this, F7Toolbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7Toolbar).call(this, props, context));
    _this.__reactRefs = {};

    _this.state = function () {
      var self = _assertThisInitialized(_assertThisInitialized(_this));

      var $f7 = self.$f7;

      if (!$f7) {
        self.$f7ready(function () {
          self.setState({
            _theme: self.$theme
          });
        });
      }

      return {
        _theme: $f7 ? self.$theme : null
      };
    }();

    (function () {
      Utils.bindMethods(_assertThisInitialized(_assertThisInitialized(_this)), ['onHide', 'onShow']);
    })();

    return _this;
  }

  _createClass(F7Toolbar, [{
    key: "onHide",
    value: function onHide(navbarEl) {
      if (this.eventTargetEl !== navbarEl) return;
      this.dispatchEvent('toolbar:hide toolbarHide');
    }
  }, {
    key: "onShow",
    value: function onShow(navbarEl) {
      if (this.eventTargetEl !== navbarEl) return;
      this.dispatchEvent('toolbar:show toolbarShow');
    }
  }, {
    key: "hide",
    value: function hide(animate) {
      var self = this;
      if (!self.$f7) return;
      self.$f7.toolbar.hide(this.refs.el, animate);
    }
  }, {
    key: "show",
    value: function show(animate) {
      var self = this;
      if (!self.$f7) return;
      self.$f7.toolbar.show(this.refs.el, animate);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var self = this;
      var props = self.props;
      var id = props.id,
          style = props.style,
          className = props.className,
          inner = props.inner,
          tabbar = props.tabbar,
          labels = props.labels,
          scrollable = props.scrollable,
          hidden = props.hidden,
          noShadow = props.noShadow,
          noHairline = props.noHairline,
          noBorder = props.noBorder,
          topMd = props.topMd,
          topIos = props.topIos,
          topAurora = props.topAurora,
          top = props.top,
          bottomMd = props.bottomMd,
          bottomIos = props.bottomIos,
          bottomAurora = props.bottomAurora,
          bottom = props.bottom,
          position = props.position;
      var theme = self.state._theme;
      var classes = Utils.classNames(className, 'toolbar', {
        tabbar: tabbar,
        'toolbar-bottom': theme && theme.md && bottomMd || theme && theme.ios && bottomIos || theme && theme.aurora && bottomAurora || bottom || position === 'bottom',
        'toolbar-top': theme && theme.md && topMd || theme && theme.ios && topIos || theme && theme.aurora && topAurora || top || position === 'top',
        'tabbar-labels': labels,
        'tabbar-scrollable': scrollable,
        'toolbar-hidden': hidden,
        'no-shadow': noShadow,
        'no-hairline': noHairline || noBorder
      }, Mixins.colorClasses(props));
      return React.createElement('div', {
        id: id,
        style: style,
        ref: function ref(__reactNode) {
          _this2.__reactRefs['el'] = __reactNode;
        },
        className: classes
      }, this.slots['before-inner'], inner ? React.createElement('div', {
        className: 'toolbar-inner'
      }, this.slots['default']) : this.slots['default'], this.slots['after-inner']);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var self = this;
      var el = self.refs.el;
      if (!el || !self.$f7) return;
      var f7 = self.$f7;
      f7.off('toolbarShow', self.onShow);
      f7.off('toolbarHide', self.onHide);
      self.eventTargetEl = null;
      delete self.eventTargetEl;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      var el = self.refs.el;
      if (!el) return;
      self.$f7ready(function (f7) {
        self.eventTargetEl = el;
        if (self.props.tabbar) f7.toolbar.setHighlight(el);
        f7.on('toolbarShow', self.onShow);
        f7.on('toolbarHide', self.onHide);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var self = this;

      if (self.props.tabbar && self.$f7) {
        self.$f7.toolbar.setHighlight(self.refs.el);
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(events) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return __reactComponentDispatchEvent.apply(void 0, [this, events].concat(args));
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }, {
    key: "refs",
    get: function get() {
      return this.__reactRefs;
    },
    set: function set(refs) {}
  }]);

  return F7Toolbar;
}(React.Component);

__reactComponentSetProps(F7Toolbar, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  tabbar: Boolean,
  labels: Boolean,
  scrollable: Boolean,
  hidden: Boolean,
  noShadow: Boolean,
  noHairline: Boolean,
  noBorder: Boolean,
  position: {
    type: String,
    default: undefined
  },
  topMd: {
    type: Boolean,
    default: undefined
  },
  topIos: {
    type: Boolean,
    default: undefined
  },
  topAurora: {
    type: Boolean,
    default: undefined
  },
  top: {
    type: Boolean,
    default: undefined
  },
  bottomMd: {
    type: Boolean,
    default: undefined
  },
  bottomIos: {
    type: Boolean,
    default: undefined
  },
  bottomAurora: {
    type: Boolean,
    default: undefined
  },
  bottom: {
    type: Boolean,
    default: undefined
  },
  inner: {
    type: Boolean,
    default: true
  }
}, Mixins.colorProps));

F7Toolbar.displayName = 'f7-toolbar';
export default F7Toolbar;